<template>
  <div class="card p-3 mb-3 shadow">
    <ClientDrugShoplistList
      title="Лист покупок"
      :prescriptions="tobuy"/>

    <ClientDrugShoplistList
      title="Куплено"
      :prescriptions="bought"/>
  </div>
</template>

<script>
import ClientDrugShoplistList from './shoplist/List';

export default {
  name: 'ClientDrugShoplist',

  props: ['prescriptions'],

  components: {ClientDrugShoplistList},

  data() {
    return {};
  },

  computed: {
    tobuy() {
      const items = this.prescriptions.filter(i => i.bought === false);

      items.sort((a, b) => {
        const aStartDate = new Date(a.startDate);
        const bStartDate = new Date(b.startDate);

        return aStartDate.getTime() - bStartDate.getTime();
      });

      return items;
    },

    bought() {
      const items = this.prescriptions.filter(i => i.bought === false);

      items.sort((a, b) => {
        const aStartDate = new Date(a.startDate);
        const bStartDate = new Date(b.startDate);

        return bStartDate.getTime() - aStartDate.getTime();
      });

      return items;
    },
  },
};
</script>
